
import { AuthService, DossierConfigService } from "@/services";
import { CodaBoxService } from "@/services/codabox-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	data() {
		return {
			token: "",
			connecting: false,
			requestingToken: false,
			tokenSentEmail: "",
			config: DossierConfigService.getCodaBoxConfig()
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [{
				to: "/settings/plugins", value: this.$ct("components.settings-plugin.plugins")
			}, { value: this.$ct("components.settings-plugin.codabox") }] as IBreadCrumb[];
		},
		mod(): MODULE {
			return MODULE.CODABOX;
		},
		hasModule(): boolean {
			return AuthService.hasModule(this.mod);
		}
	},
	methods: {
		async requestToken() {
			if (this.requestingToken) return;
			this.requestingToken = true;
			this.tokenSentEmail = "";
			try {
				const result = await CodaBoxService.requestAccessToken();
				this.tokenSentEmail = result.email;
			} catch (err) {
				this.$wf.notify(this.$ct("common.error"), "danger", 3000, "exclamation-triangle");
			} finally {
				this.requestingToken = false;
			}
		},
		async connect() {
			if (this.connecting || !this.token) return;
			this.connecting = true;
			try {
				await CodaBoxService.exchangeToken(this.token, this.config.StartDate);
				this.config.Connected = true;
				this.$wf.notify(this.$ct("connected"), "success", 3000, "check");
				this.token = "";
			} catch (err) {
				this.$wf.notify(this.$ct("common.error"), "danger", 3000, "exclamation-triangle");
			} finally {
				this.connecting = false;
			}
		},
		async saveDocumentTypes() {
			try {
				await CodaBoxService.updateSettings(this.config);
			} catch (err) {
				this.$wf.notify(this.$ct("common.error"), "danger", 3000, "exclamation-triangle");
			}
		},
		async disconnect() {
			let confirm = await this.$wf.confirm(
				this.$ct("confirm-disconnect"),
				this.$ct("common.yes"),
				this.$ct("common.no"),
				this.$ct("common.warning"),
				"warning"
			);
			if (!confirm) return;
			try {
				await CodaBoxService.disconnect();
				this.config.Connected = false;
				this.$wf.notify(this.$ct("not-connected"), "success", 3000, "check");
			} catch (err) {
				this.$wf.notify(this.$ct("common.error"), "danger", 3000, "exclamation-triangle");
			}
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "components.settings-plugin.CodaBox"
	}
});
